import { render } from "./Modal.vue?vue&type=template&id=7d6bc4ed&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=7d6bc4ed&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7d6bc4ed"

export default script